import styles from "./Error.module.scss";

export function Error(props) {
  return <div {...props} className={styles.error} />;
}
